import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WarningState {
  show: boolean;
  renew: boolean;
  upgrade: boolean;
  noPlan: boolean;
}

const initialState: WarningState = {
  show: false,
  renew: false,
  upgrade: false,
  noPlan: false,
};

const warningSlice = createSlice({
  name: "warning",
  initialState,
  reducers: {
    setWarning: (state, action: PayloadAction<Partial<WarningState>>) => {
      const updated = { ...state, ...action.payload };
      updated.show = updated.renew || updated.upgrade || updated.noPlan;
      return updated;
    },
    clearWarning: () => initialState,
  },
});

export const { setWarning, clearWarning } = warningSlice.actions;
export default warningSlice.reducer;
